import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule, NgbCarouselConfig, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { AuthGuard } from './_guards/auth.guard';
import { AuthVoteGuard } from './_guards/auth-vote.guard';
import { StdGuard } from './_guards/std.guard';
import { AlertComponent } from './_directives/alert.component';
import { AlertService } from './_services/alert.service';
import { AuthService } from './_services/auth.service';

// Routing
import { routing } from './app.routing';

// Components
import { AppComponent } from './app.component';

import { SettingsModule } from './_layout/settings/settings.module';
import { ThemeSettingsConfig } from './_layout/settings/theme-settings.config';
import { MenuSettingsConfig } from './_layout/settings/menu-settings.config';

import { HeaderComponent } from './_layout/header/header.component';
import { VerticalComponent as HeaderVerticalComponent } from './_layout/header/vertical/vertical.component';
import { HorizontalComponent as HeaderHorizontalComponent } from './_layout/header/horizontal/horizontal.component';
import { FullLayoutNavbarComponent } from './_layout/header/full-layout-navbar/full-layout-navbar.component';

import { FooterComponent } from './_layout/footer/footer.component';
import { NavigationComponent as AppNavigationComponent } from './_layout/navigation/navigation.component';
import { NavigationVoteComponent } from './_layout/navigation-vote/navigation-vote.component';
import { NavigationSecurityComponent } from './_layout/navigation-security/navigation-security.component';
import { NavigationBoothComponent } from './_layout/navigation-booth/navigation-booth.component';
//Parent
import { HeaderParentComponent } from './_layout/header-parent/header-parent.component';
import { VerticalParentComponent as HeaderVerticalParentComponent } from './_layout/header-parent/vertical-parent/vertical-parent.component';


import { HeaderBoothComponent } from './_layout/header-booth/header-booth.component';
import { VerticalBoothComponent as HeaderVerticalBoothComponent } from './_layout/header-booth/vertical-booth/vertical-booth.component';

import { VerticalSTDComponent } from './_layout/header-std/vertical/vertical.component'
import { HeaderSTDComponent } from './_layout/header-std/header.component';

import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';
import { VoteLayoutComponent } from './_layout/vote-layout/vote-layout.component';
import { ParentLayoutComponent } from './_layout/parent-layout/parent-layout.component';
import { VerticalnavParentComponent } from './_layout/navigation-parent/verticalnav-parent/verticalnav-parent.component';
import { NavigationParentComponent } from './_layout/navigation-parent/navigation-parent.component';


import { RegisterComponent } from './register';
import { SocialSigninComponent } from './social-signin/social-signin.component';


import { ChangelogComponent } from './changelog/changelog.component';

import { NavbarService } from './_services/navbar.service';
import { VerticalnavComponent } from './_layout/navigation/verticalnav/verticalnav.component';
import { VerticalnavStdComponent } from './_layout/navigation-std/verticalnav-std/verticalnav-std.component';
import { HorizontalnavComponent } from './_layout/navigation/horizontalnav/horizontalnav.component';

import { VerticalnavPncComponent } from './_layout/navigation-booth/verticalnav-booth/verticalnav-booth.component';
import { HorizontalnavPncComponent } from './_layout/navigation-booth/horizontalnav-booth/horizontalnav-booth.component';

import { NavigationStdComponent } from './_layout/navigation-std/navigation-std.component';
// perfect scroll bar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
// spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { DeviceDetectorService } from 'ngx-device-detector';
import { RouterModule } from '@angular/router';
import { DataApiService } from './_services/data.api';
import { BlockUIModule } from 'ng-block-ui';
import { StudentLayoutComponent } from './_layout/student-layout/student-layout.component';
import { MainComponent } from './main/main.component';
import { MainOtherComponent } from './main-other/main-other.component';
import { AuthStdGuard } from './_guards/auth-std.guard';
import { AuthParentGuard } from './_guards/auth-parent.guard';
import { MainService } from './_services/main.service';
import { TokenInterceptor } from './_interceptor/token.interceptor';
import { TranslatorService } from 'src/app/_services/translator.service';
import { NgxPermissionsModule } from 'ngx-permissions';
import { PusherService } from './_services/pusher.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';;
import { ServiceWorkerModule } from '@angular/service-worker'
import { NgxPicaService } from '@digitalascetic/ngx-pica';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
// google maps
import { AgmCoreModule } from '@agm/core';;
import { DateDifferencePipe } from './_pipes/date-difference.pipe'; import { QuillModule } from 'ngx-quill';
import { BlockTemplateComponent } from './_layout/blockui/block-template.component';
import { FullLayoutComponent } from './_layout/full-layout/full-layout.component';
import { PipeModule } from './_pipes/pipe/pipe.module';
import { BreadcrumbModule } from './_layout/breadcrumb/breadcrumb.module';
import { MatchHeightModule } from './content/partials/general/match-height/match-height.module';
import { PartialsModule } from './content/partials/partials.module';
import { LineGuard } from './_guards/line.guard';
import { LineParentGuard } from './_guards/line-parent.guard';
import { DeActivatedGuard } from './_guards/deactivated.guard'; 
import { SecurityGuardLayoutComponent } from './_layout/security-guard-layout/security-guard-layout.component';
import { BoothLayoutComponent } from './_layout/booth-layout/booth-layout.component';
import { AuthSecurityGuard } from './_guards/auth-security.guard';
import { AuthPNCGuard } from './_guards/auth-pnc.guard';
function appInitializer(authService: AuthService) {
  return () => {
    return new Promise<void>((resolve) => {
      console.log("dd")
      authService.getUserByToken().subscribe(() => {
        resolve();
      });
    });
  };
}

@NgModule({
  imports: [
    BrowserModule,
    PartialsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatchHeightModule,
    BreadcrumbModule,
    NgbModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    routing,
    SettingsModule.forRoot(ThemeSettingsConfig, MenuSettingsConfig),
    PerfectScrollbarModule,
    NgxSpinnerModule,
    QuillModule.forRoot(),
    LoadingBarRouterModule,
    BlockUIModule.forRoot({
      template: BlockTemplateComponent
    }),
    PipeModule,
    NgxPermissionsModule.forRoot(),
    ToastrModule.forRoot({
      maxOpened: 5,
      autoDismiss: true,
      easeTime: 300,
      progressBar: true,
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyChiQ0VjcKH-SA9Tj4AMXP2R9BaCvvbulQ',
      libraries: ['geometry']
    }),
  ],
  declarations: [
    AppComponent,
    PublicLayoutComponent,
    PrivateLayoutComponent,
    VoteLayoutComponent,
    SecurityGuardLayoutComponent,
    BoothLayoutComponent,
    StudentLayoutComponent,
    ParentLayoutComponent,
    VerticalnavParentComponent,
    HeaderComponent,
    FullLayoutNavbarComponent,
    HeaderHorizontalComponent,
    HeaderVerticalComponent,
    HeaderVerticalParentComponent,
    VerticalSTDComponent,
    
    HeaderParentComponent,
    HeaderBoothComponent,
    // VerticalBoothComponent,
   HeaderVerticalBoothComponent,
    HeaderSTDComponent,
    FooterComponent,
    AppNavigationComponent,
    NavigationVoteComponent,
    NavigationSecurityComponent,
    NavigationParentComponent,
    NavigationBoothComponent,
    NavigationStdComponent,
    AlertComponent,
    RegisterComponent,
    SocialSigninComponent,
    ChangelogComponent,
    VerticalnavComponent,
    VerticalnavStdComponent,
    HorizontalnavComponent,
    HorizontalnavPncComponent,
    VerticalnavPncComponent,
    BlockTemplateComponent,
    FullLayoutComponent,
    MainComponent,
    MainOtherComponent,
  ],
  providers: [
    AuthGuard,
    AuthVoteGuard,
    AuthSecurityGuard,
    AuthPNCGuard,
    StdGuard,
    AuthStdGuard,
    LineGuard,
    LineParentGuard,
    AuthParentGuard,
    DeActivatedGuard,
    AlertService,
    NavbarService,
    DataApiService,
    AuthService,
    MainService,
    TranslatorService,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerGestureConfig
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },

    NgbCarouselConfig,
    NgbModalConfig,
    PusherService,
    NgxPicaService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
  ],
  entryComponents: [
    BlockTemplateComponent
  ],
  bootstrap: [AppComponent],
  exports: [RouterModule]
})

export class AppModule {

}

